import Api from '@common/services/api';

export const toggleMarkAsRead = async (orgId: string, conversationId: string, shouldMarkAsRead: boolean) => {
  return Api.post(`/v3/organisations/${orgId}/conversations/${conversationId}/${shouldMarkAsRead ? 'open' : 'unread'}`);
};
